import { useCallback } from 'react'
import { Transition, useReducedMotion } from 'framer-motion'

type MotionSafeFunc = (v: Transition) => Transition

const useMotionSafe = (): MotionSafeFunc => {
  const reducedMotion = useReducedMotion()
  const motionSafe = useCallback(
    (value: Transition): Transition => (reducedMotion ? { duration: 0 } : value),
    [reducedMotion]
  )
  return motionSafe
}

export default useMotionSafe
